import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import { service } from '@/share';

export const createChild = createAsyncThunk<void, ChildJson, ThunkApiType>(
  'child/create',
  async (input, _thunkApi) => {
    await service.child.createChild(input);
  },
);

export const updateChild = createAsyncThunk<void, ChildJson, ThunkApiType>(
  'child/update',
  async (input, _thunkApi) => {
    await service.child.updateChild(input);
  },
);

export const deleteChild = createAsyncThunk<void, ChildJson, ThunkApiType>(
  'child/delete',
  async (input, _thunkApi) => {
    await service.child.deleteChild(input);
  },
);
